export const colors = {
  primary: '#1a202c',
  secondary: '#2d3748',
  tertiary: '#ed8936',
  white: '#fff',
  graylight: '#828282',
  graydark: '#222222',
  redSupport: '#ce0707',
};
